import React from 'react'
import PropTypes from 'prop-types'

import IconPhone from '@assets/icons/phone.svg?react'

const CallUsBody = ({ 
  message = 'Sorry, it looks like your home does not qualify for a Mass Save Energy Assessment.\n\nFor more information, please call a HomeWorks Energy Specialist at (781) 305-3319.',
  DisplayLogo = IconPhone 
}) => {
  let url = ''
  if (message && message.includes('https://www')) {
    const messageWithUrl = message.split(': ')
    message = messageWithUrl[0]
    url = messageWithUrl[1]
  }
  const renderMessage = (message) => {
    let parser = new DOMParser()
    parser = parser.parseFromString(message, 'text/html')
    return parser.body.innerHTML
  }
  const LogoComponent = DisplayLogo || IconPhone
  return (
    <div className="text-center">
      {LogoComponent && <LogoComponent className="h-[2.4rem] w-[2.4rem] mb-6 mx-auto flex-shrink-0" />}
      <p
        className="whitespace-pre-wrap"
        dangerouslySetInnerHTML={{ __html: renderMessage(message) }}
      ></p>
      {url && <a href={url} className="text-primary-blue hover:underline">Mass Save</a>}
    </div>
  )
}

CallUsBody.propTypes = {
  message: PropTypes.string,
  DisplayLogo: PropTypes.elementType,
}

export default CallUsBody
